import React from "react";
import { toast } from "react-toastify";
import { Input, Select, Textarea } from "../../../components/form";
import { Button } from "../../../components/button";
import { useCreateCustomerTask } from "../hooks";
import { useUsers } from "../../users/hooks";
import { CustomerSelectSearch } from "../../customers/components";
import { CUSTOMER_TASK_PRIORITY_LABELS } from "../../../helpers/enum-labels";

interface IProps {
  customerId?: number;
  onCompleted: () => void;
}

export const CustomerTaskForm: React.FC<IProps> = ({ customerId, onCompleted }) => {
  const { data: usersData } = useUsers({ where: {}, limit: 100, offset: 0 });
  const { form, submit, loading } = useCreateCustomerTask({
    defaultValues: { customerId, priority: 1 },
    onCompleted: () => {
      toast.success("La tâche a été créée avec succès");
      form.reset({ customerId, priority: 1 });
      onCompleted();
    },
  });

  return (
    <div className="flex flex-wrap gap-3 items-end">
      {!customerId && (
        <CustomerSelectSearch form={form} name="customerId" label="Client" />
      )}
      <Input
        label="Titre"
        className="w-full"
        {...form.register("title", { required: true })}
      />
      <Textarea
        label="Description"
        className="w-full"
        {...form.register("description", { required: true })}
      />
      <Select label="Priorité" className="w-full" {...form.register("priority")}>
        {Object.entries(CUSTOMER_TASK_PRIORITY_LABELS).map(([value, { label }]) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </Select>
      <Select label="Assigné à" className="w-full" {...form.register("assignedToId")}>
        <option value="">Moi-même</option>
        {usersData?.users?.results?.map((user) => (
          <option key={user.id} value={user.id}>
            {user.firstname} {user.lastname}
          </option>
        ))}
      </Select>
      <Button onClick={submit} loading={loading} disabled={loading}>
        Créer la tâche
      </Button>
    </div>
  );
};
